<template>
  <div id="admin_rpts_promotions_rpt">
    <CardedSectionHeader
      icon="mdi-form-map"
      label="Report Filter"
      id="admin_promotions_report_filter"
    ></CardedSectionHeader>
    <CardedForm
      ref="admin_promotions_report_filter_form_ref"
      id="admin_promotions_report_filter_form_form"
      title="You can filter by: Start date, End date, Promotion's views, Expiry, Status and Location"
      :is_loading="is_loading"
      @on-submit-form="filter_report"
      :errors="errors"
      :message="message"
      @on-auto-fill="on_auto_fill"
      cmp_class="ma-0 pl-5 pr-5 pt-0 white"
      @on-clear-form="on_clear_form"
    >
      <v-row no-gutterss class="pa-0 mb-0" :key="date_input_key">
        <v-col class="pt-0 pb-0 mb-0">
          <DateField
            label="Start Date"
            v-model="form.start_date_display"
            :disabled="is_loading"
            :validation_rules="form_validations.start_date_display"
            :min="'2018-01-01'"
            :max="form.date_today"
          ></DateField>
        </v-col>
        <v-col class="pt-0 pb-0 mb-0">
          <DateField
            label="End Date"
            v-model="form.end_date_display"
            :disabled="is_loading"
            :validation_rules="form_validations.end_date_display"
            :min="form.start_date_display"
            :max="form.date_today"
          ></DateField>
        </v-col>
      </v-row>
      <v-row no-gutterss class="pa-0 mb-0">
        <v-col class="pt-0 pb-0 mb-0">
          <SelectField
            v-model="form.views"
            :options="views"
            :small_chips="false"
            :is_small="true"
            :validation_rules="form_validations.views"
            label="Promotion's views"
            icon="mdi-eye"
            :disabled="is_loading"
            item_text="name"
            item_value="views"
          ></SelectField>
        </v-col>
        <v-col class="pt-0 pb-0 mb-0">
          <SelectField
            v-model="form.expiry"
            :options="expiries"
            :small_chips="false"
            :is_small="true"
            :validation_rules="form_validations.expiry"
            label="Expiry"
            icon="mdi-bell"
            :disabled="is_loading"
            item_text="name"
            item_value="value"
          ></SelectField>
        </v-col>
        <v-col class="pt-0 pb-0 mb-0">
          <SelectField
            v-model="form.status"
            :options="statuses"
            :small_chips="false"
            :is_small="true"
            :validation_rules="form_validations.status"
            label="Status"
            icon="mdi-alert"
            :disabled="is_loading"
            item_text="name"
            item_value="value"
          ></SelectField>
        </v-col>
      </v-row>
      <v-row no-gutterss class="pa-0 mb-0">
        <v-col no-gutters class="pb-0 pt-0 mb-0">
          <SelectField
            v-model="form.district_id"
            :options="districts"
            :small_chips="false"
            :validation_rules="form_validations.district_id"
            label="District"
            icon="mdi-pen-plus"
            :disabled="is_loading"
            item_text="name"
            item_value="id"
          ></SelectField>
        </v-col>
        <v-col no-gutters class="pb-0 pt-0 mb-0">
          <SelectField
            v-model="form.city_id"
            :options="cities"
            :small_chips="false"
            :validation_rules="form_validations.city_id"
            label="City"
            icon="mdi-pen-plus"
            :disabled="is_loading"
            item_text="name"
            item_value="id"
          ></SelectField>
        </v-col>
      </v-row>
      <v-row no-gutterss class="pa-0 mb-0">
        <v-col no-gutters class="pb-0 pt-0 mb-0">
          <SelectField
            v-model="form.ward_id"
            :options="wards"
            :small_chips="false"
            :validation_rules="form_validations.ward_id"
            label="Ward"
            icon="mdi-pen-plus"
            :disabled="is_loading"
            item_text="name"
            item_value="id"
          ></SelectField>
        </v-col>
        <v-col no-gutters class="pb-0 pt-0 mb-0">
          <SelectField
            v-model="form.street_id"
            :options="streets"
            :small_chips="false"
            :validation_rules="form_validations.street_id"
            label="Street"
            icon="mdi-pen-plus"
            :disabled="is_loading"
            item_text="name"
            item_value="id"
          ></SelectField>
        </v-col>
      </v-row>
      <TextField
        v-model="form.physical_address"
        :validation_rules="form_validations.physical_address"
        label="Physical Address: (e.g plot 22211 phase 4, Gaborone) Or Manual Directions"
        icon="mdi-pen-plus"
        :disabled="is_loading"
      ></TextField>
    </CardedForm>
    <CardedSectionHeader
      icon="mdi-form-map"
      label="Report Table"
      id="admin_promotions_report_table"
    ></CardedSectionHeader>
    <CardedTable
      :items="items"
      :headers="headers"
      :show_search="true"
      :show_description="false"
      :show_header_bar="true"
      :has_margin="false"
    >
      <template v-slot:controls>
        <div>
          <h4 class="pt-3">{{ report_message }}</h4>
        </div>
      </template>

      <template v-slot:[`item.expiry`]="{ item }">
        <span class="red--text" v-if="item.expiry == 'expired' && parseInt(item.has_been_ended) == 0"><b>Expired</b></span>
        <span class="red--text" v-if="parseInt(item.has_been_ended) == 1"><b>Ended</b></span>
        <span class="warning--text" v-if="item.expiry == 'pending' && parseInt(item.has_been_ended) == 0"><b>Not Yet</b></span>
        <span class="success--text" v-if="item.expiry == 'live' && parseInt(item.has_been_ended) == 0"><b>Happening</b></span>
      </template>
      <template v-slot:[`item.has_been_ended`]="{ item }">
        <span class="red--text" v-if="parseInt(item.has_been_ended) == 1"><b>Ended</b></span>
        <!-- <span class="blue--text" v-if="parseInt(item.is_verified) == 1"><b>Processing</b></span> -->
        <span class="green--text" v-if="parseInt(item.has_been_ended) == 0"><b>Active</b></span>
      </template>

      <template v-slot:[`item.actions`]="{ item }">
        <v-btn @click="on_view_item(item)" x-small rounded text color="success">
          <v-icon>mdi-eye</v-icon>
        </v-btn>
      </template>
    </CardedTable>
  </div>
</template>

<script>
/*
  start day && end day
  by views -> all, day, week, month, 3 months, 6 months, 
  expiry      -> all, expired, ended, not yet, happening
  status      -> all, active, ended
  business category, subcategory -> all
  location   -> all
*/
import CardedTable from "../../../components/CardedTable";
import CardedSectionHeader from "../../../components/CardedSectionHeader";
import CardedForm from "../../../components/CardedForm";
import SelectField from "../../../components/SelectField";
import TextField from "../../../components/TextField";
import RedText from "../../../components/RedText";
import DateField from "../../../components/DateField";
import ServerClient from "../../../lib/ServerClient";
import Utils from "../../../lib/Utils";
export default {
  name: "AdminReportsPromotions",
  components: {
    CardedTable,
    DateField,
    RedText,
    SelectField,
    CardedSectionHeader,
    CardedForm,
    TextField
  },
  props: {
    is_loading: {
      type: Boolean,
      default: false,
    },
    user: {
      type: Object,
      default: () => {
        return ServerClient.Login.get_logged_in_user();
      },
    },
  },
  data: () => {
    return {
      _user: null,
      errors: [],
      message: "",
      form: {
        start_date_display: Utils.get_today_date_str(),
        end_date_display: Utils.get_today_date_str(),
        date_today: Utils.get_today_date_str(),
        category_id: -1,
        sub_category_id: -1,
        district_id: -1,
        city_id: -1,
        ward_id: -1,
        street_id: -1,
        physical_address: "",
        views: -1,
        expiry: "-1",
        status: "-1"
      },
      form_validations: {
        start_date_display: [],
        end_date_display: [],
        category_id: [],
        district_id: [],
        city_id: [],
        ward_id: [],
        street_id: [],
        physical_address: [],
        views: [],
        expiry: [],
        status: []
      },
      items: [],
      headers: [
        {
          text: "Title",
          align: "start",
          sortable: true,
          value: "title",
          filterable: true,
        },
        {
          text: "Business",
          align: "start",
          sortable: false,
          value: "business.name",
          filterable: true,
        },
        {
          text: "Starts",
          align: "center",
          sortable: true,
          value: "starts_on",
          filterable: true,
        },
        {
          text: "Ends",
          align: "center",
          sortable: true,
          value: "ends_on",
          filterable: true,
        },
        {
          text: "Expiry",
          align: "start",
          sortable: true,
          value: "expiry",
          filterable: true,
        },
        {
          text: "Status",
          align: "start",
          sortable: true,
          value: "has_been_ended",
          filterable: true,
        },
        { text: "", value: "actions", sortable: false, align: "end", },
      ],
      categories: [],
      districts: [],
      report_message: "",
      date_input_key: "promo_date_inputs_key_1",
      date_input_key_truck : 1,
      views: [{
        id:0,
        name: "all",
        views: -1,
      },{
        id:1,
        name: "no views",
        views: 0,
      },{
        id:2,
        name: "very little - (23 views)",
        views: 23,
      },{
        id:3,
        name: "few - (50 views)",
        views: 50,
      },{
        id:4,
        name: "modorate - (120 views)",
        views: 120,
      },{
        id:5,
        name: "many - (240 views)",
        views: 240,
      },{
        id:6,
        name: "alot -(500 views)",
        views: 500,
      }],
      expiries:[{
        id:0,
        name: "all",
        value: "-1",
      },{
        id:1,
        name: "pending (not yet started)",
        value: "not yet",
      },{
        id:2,
        name: "happening (on going)",
        value: "happening",
      },{
        id:3,
        name: "ended",
        value: "ended",
      },{
        id:4,
        name: "expired",
        value: "expired",
      }],
      statuses: [{
        id:0,
        name: "all",
        value: "-1",
      },{
        id:1,
        name: "active",
        value: "active",
      },{
        id:2,
        name: "ended",
        value: "ended",
      }]
    };
  },
  methods: {
    on_clear_form(){
      this.form.start_date_display =  Utils.get_today_date_str();
      this.form.end_date_display = Utils.get_today_date_str();
      this.form.date_today = Utils.get_today_date_str();
      this.form.category_id = -1;
      this.form.sub_category_id = -1;
      this.form.district_id = -1;
      this.form.city_id = -1;
      this.form.ward_id = -1;
      this.form.street_id = -1;
      this.form.physical_address = "";
      this.form.views = -1;
      this.form.expiry = "-1";
      this.form.status = "-1";
      this.date_input_key_truck = this.date_input_key_truck + 1;
      this.date_input_key = "promo_date_inputs_key_" + this.date_input_key_truck;
    },
    on_auto_fill() {
        this.refresh_table();
    },
    filter_report() {
        this.refresh_table();
    },
    get_report_dependencies() {
      ServerClient.Reports.get_register_reports_dependencies(
        {
        },
        (res) => {
          //all 
          var cats = [{
            id: -1,
            name: "all",
            description: "",
            sub_categories: [{
              id: -1,
              category_id: -1,
              name: "all",
              description: ""
            }]
          }].concat(res.categories);
          this.categories = cats;

          var districts = [{
            id: -1,
            name: "all",
            country_id: 1, //country botswana
            cities: [],
            wards: []
          }].concat(res.districts);
          for (var index = 0; index < districts.length; index++) {
            districts[index].cities = [{
              id: -1,
              name: "all",
              district_id: -1,
            }].concat(districts[index].cities);
            districts[index].wards = [{
              id: -1,
              name: "all",
              district_id: -1,
              country_id: 1,
              streets: []
            }].concat(districts[index].wards);
            //all wards
            for (var ward_index = 0; ward_index < districts[index].wards.length; ward_index++) {
              districts[index].wards[ward_index].streets = [{
                id: -1,
                name: "all",
                country_id: 1,
                district_id: districts[index].id,
                ward_id: districts[index].wards[ward_index].id
              }].concat(districts[index].wards[ward_index].streets)
            }
          }

          this.districts = districts;
          this.refresh_table();
        },
        (errors) => {
          console.log(errors);
          this.errors = errors;
          this.$refs.admin_promotions_report_filter_form_ref.show_error_dialog();
        }
      );
    },
    load_items(filter_config) {
      this.$emit("on-show-loader");
      ServerClient.Reports.get_promotions_report(
        {
          ...filter_config
        },
        (res) => {
          this.items = res;
          this.process_report_message();
          this.$emit("on-hide-loader");
          var options = {
            offset: 50,
            duration: 1000,
            easing: "easeInOutCubic",
          };
            this.$vuetify.goTo("#admin_promotions_report_table", options);
        },
        (errors) => {
          this.$emit("on-hide-loader");
          this.errors = errors;
          this.$refs.admin_promotions_report_filter_form_ref.show_error_dialog();
        }
      );
    },
    on_view_item(item) {
      this.$router.push("/admin/promotions/list/view/" + item.id);
    },
    refresh_table() {
      this.errors = [];
      var start_time_str = this.form.start_date_display + " 00:30:00 AM ";
      var start_time = Utils.date_str_to_php_time(start_time_str);
      var end_time_str = this.form.end_date_display + " 11:30:00 PM ";
      var end_time = Utils.date_str_to_php_time(end_time_str);
      if (start_time == end_time) {
        this.errors.push("Start time cannot be equal to end time");
        this.$refs.admin_promotions_report_filter_form_ref.show_error_dialog();
        return false;
      }
      if (start_time > end_time) {
        this.errors.push("Start time cannot be greater than end time");
        this.$refs.admin_promotions_report_filter_form_ref.show_error_dialog();
        return false;
      }

      this.load_items({
          ...this.form,
      });
    },
    process_report_message() {
      var num_str = "";
      if (this.items.length == 0) {
        num_str = " were no  promotions ";
      } else if (this.items.length == 1) {
        num_str = " was only (1) one promotion ";
      } else if (this.items.length > 1) {
        num_str = " were " + this.items.length + " promotions ";
      }

      var start_word = Utils.date_str_to_words(
        this.form.start_date_display,
        true,
        "of"
      );
      var end_word = Utils.date_str_to_words(this.form.end_date_display, true, "of");
      var msg = "";
      if (this.form.start_date_display == this.form.end_date_display) {
        msg = "There " + num_str + " on the " + start_word;
      } else {
        msg =
          "There " +
          num_str +
          " between the " +
          start_word +
          " and the " +
          end_word;
      }
      this.report_message = msg;
    },
  },
  computed: {
    sub_categories() {
      var temp = [];
      for (var index = 0; index < this.categories.length; index++) {
        var cat = this.categories[index];
        if (parseInt(cat.id) == parseInt(this.form.category_id)) {
          temp = cat.sub_categories;
          break;
        }
      }
      return temp;
    },
    cities() {
      var temp = [];
      for (var index = 0; index < this.districts.length; index++) {
        var district = this.districts[index];
        if (parseInt(district["id"]) == parseInt(this.form.district_id)) {
          temp = district.cities;
          break;
        }
      }
      return temp;
    },
    wards() {
      var temp = [];
      for (var index = 0; index < this.districts.length; index++) {
        var district = this.districts[index];
        if (parseInt(district["id"]) == parseInt(this.form.district_id)) {
          temp = district.wards;
          break;
        }
      }
      return temp;
    },
    streets() {
      var temp = [];
      for (var index = 0; index < this.districts.length; index++) {
        var district = this.districts[index];
        var found = false;
        if (parseInt(district["id"]) == parseInt(this.form.district_id)) {
          var wards = district.wards;
          for (var index2 = 0; index2 < wards.length; index2++) {
            var ward = wards[index2];
            if (parseInt(ward.id) == parseInt(this.form.ward_id)) {
              temp = ward.streets;
              found = true;
              break;
            }
          }
        }
        if (found == true) {
          break;
        }
      }
      return temp;
    },
  },
  mounted() {
    this._user = ServerClient.Login.get_logged_in_user();
    //nyd
    //if is not admin please redirect this user to the login screen

    this.$emit("set-page-attributes", {
      title: "Promotions Report",
      crumps: [
        {
          text: "Admin",
          disabled: false,
          href: "/admin",
        },
        {
          text: "Reports",
          disabled: false,
          href: "/admin/reports",
        },
        {
          text: "Promotions Report",
          disabled: true,
          href: "/admin/reports/promotions",
        },
      ],
    });

    this.get_report_dependencies();

    var options = {
      offset: 50,
      duration: 1000,
      easing: "easeInOutCubic",
    };
    this.$vuetify.goTo("#admin_rpts_promotions_rpt", options);
  },
};
</script>